$(function () {
  'use strict';

  var $carousels = $('.js-app-carousel');

  // Early exit
  if(!$carousels.length) return;

  var update = function (slick, currentSlide) {
    var $slides = slick.$slides;

    $slides.removeClass('is-displayed');
    $slides.filter('[data-slick-index="' + parseInt(currentSlide - 1) + '"]').addClass('is-displayed');
    $slides.filter('[data-slick-index="' + parseInt(currentSlide) + '"]').addClass('is-displayed');
    $slides.filter('[data-slick-index="' + parseInt(currentSlide + 1) + '"]').addClass('is-displayed');
  };

  $carousels.each(function(index, carousel) {
    var $carousel = $(carousel);
    var $items = $carousel.find('.js-app-carousel-items');

    $items.on('init', function (event, slick) {
      update(slick, slick.currentSlide);
    });

    $items.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
      update(slick, nextSlide);
    });

    $items.on('afterChange', function (event, slick, currentSlide) {
      update(slick, currentSlide);
    });

    $items.slick({
      dots: true,
      infinite: true,
      variableWidth: true,
      centerMode: true,
        autoplay: true,
        autoplaySpeed: 4000,
      initialSlide: 1,
        slidesToShow: 2,
      prevArrow: $carousel.find('.js-app-carousel-prev'),
      nextArrow: $carousel.find('.js-app-carousel-next'),
    });
  });

});
